import { DOCS_FORM_NAMES } from "core/consts";
import { FormFieldConfigFactory } from "../..";
import { createEntDischargeLetterPdf } from "./pdfCreator";
import { DischargeLetterENTFormSchema } from "./schema";
import { DischargeLetterENTFormSections } from "./sections";

export const getDischargeLetterENTFormConfig: FormFieldConfigFactory<
  typeof DOCS_FORM_NAMES.DISCHARGE_LETTER_ENT
> = () => {
  return {
    config: { canPrint: false, canSendToHis: true },
    getInitialValue: ({ value }) => {
      return {
        additional_diagnostic_findings:
          value?.additional_diagnostic_findings ?? "",
        admission_medications: value?.admission_medications ?? "",
        anamnesis: value?.anamnesis ?? "",
        clinical_course: value?.clinical_course ?? "",
        diagnoses: value?.diagnoses ?? "",
        discharge_medications: value?.discharge_medications ?? "",
        laboratory_parameters: value?.laboratory_parameters ?? "",
        parameters: value?.parameters ?? "",
        recommendations: value?.recommendations ?? "",
        therapy: value?.therapy ?? "",
      };
    },
    header: ({ translations }) =>
      translations.extractDocs.dischargeLetter.formEnt.title,
    pdfConfig: {
      downloadPdfFileName: (translations) =>
        translations.extractDocs.dischargeLetter.generatedPdf.savedFileName,
      pdfCreator: createEntDischargeLetterPdf,
    },
    schema: DischargeLetterENTFormSchema,
    sections: DischargeLetterENTFormSections,
  };
};
